class ProductFormPriceUpdater {
  constructor() {
    this.form = document.getElementById("albumDetailsForm");
    this.priceSelectors = ".price__regular .price-item--regular, .price__sale .price-item--sale";
    this.basePrice = this.getBasePrice();
    this.selectedOptions = new Map();
    this.fixedBarPrice = document.querySelector(".total-price-amount");
    this.mediaOptions = document.querySelectorAll('input[name="properties[media-type]"]');
    this.displayOptions = document.querySelectorAll(
      "#display-section .album-details-form__field"
    );
    this.keyholeMountsSection = document.getElementById(
      "keyhole-mounts-section"
    );
    this.recordSizeSection = document.getElementById("record-size-section");
    this.serviceTypeSection = document.getElementById("service-type-section");
    this.serviceTypeOptions = document.querySelectorAll(".service-type-option");

    // Initialize state
    this.init();
  }

  /**
   * 
   * @returns 
   */
  init() {
    if (!this.form) return;

    // Set default media type to records
    this.currentMediaType = "records";
    this.checkFirstRadiosInGroups();
    this.initializeEventListeners();
    this.initializeSelectedOptions();
    this.handleCustomNoteVisibility();
    this.setupFormDataCollection();
    this.initializeDisplayFiltering();
    this.initializeKeyholeMountsVisibility();
    this.initializeServiceTypeVisibility();
  }

  getBasePrice() {
    const priceElement = document.querySelector(this.priceSelectors);
    if (!priceElement) return 0;

    // Remove currency symbol and convert to number
    const price = priceElement.textContent.replace(/[^0-9.-]/g, "");
    return parseFloat(price);
  }

  checkFirstRadiosInGroups() {
    if (!this.form) return;

    // Groups with no default — user must actively select.
    const skipGroups = new Set([
      'properties[record-size]',
      'properties[display-preference]',
    ]);

    // Get all unique radio button names (groups)
    const radioGroups = new Set();
    this.form.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radioGroups.add(radio.name);
    });

    // For each group, check the first radio button
    radioGroups.forEach((groupName) => {
      if (skipGroups.has(groupName)) return;

      const firstRadio = this.form.querySelector(
        `input[type="radio"][name="${groupName}"]`
      );
      if (firstRadio) {
        firstRadio.checked = true;
        // Trigger change event
        const event = new Event("change", {
          bubbles: true,
          cancelable: true,
        });
        firstRadio.dispatchEvent(event);
      }
    });
  }

  initializeEventListeners() {
    if (!this.form) return;
    const priceRangeSlider = document.getElementById("priceSlider");
    if (priceRangeSlider) {
      priceRangeSlider.addEventListener("input", (e) => {
        this.handlePriceRangeChange(e);
      });
    }
    
    // Listen for changes on all radio inputs
    this.form.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener("change", (e) => {
        // Ensure the clicked radio is checked
        input.checked = true;
        
        // Uncheck other radios in the same group
        this.form.querySelectorAll(`input[name="${input.name}"]`).forEach((radio) => {
          if (radio !== input) {
            radio.checked = false;
          }
        });

        this.handleOptionChange(e);

        if (input.name === "properties[display-preference]") {
          this.handleCustomNoteVisibility();
        }

        // Only handle media type changes for visibility
        if (input.name === "properties[media-type]") {
          const selectedType = input.getAttribute("data-type");
          this.currentMediaType = selectedType;
          
          // Check if this is the initial media type selection (not a reset-triggered event)
          if (!input.hasAttribute('data-reset-triggered')) {
            // Reset all form fields when media type changes (with small delay for proper execution)
            setTimeout(() => {
              this.resetAllFormFields(input.value);
            }, 10);
          } else {
            // Remove the reset trigger flag
            input.removeAttribute('data-reset-triggered');
          }
          
          this.filterDisplayOptions(selectedType);
          this.toggleKeyholeMounts(selectedType);
          this.updateServiceTypeVisibility(selectedType);
        }
      });
    });

    // Listen for changes on keyhole mount checkboxes
    if (this.keyholeMountsSection) {
      this.keyholeMountsSection.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.addEventListener("change", (e) => {
          this.handleKeyholeMountChange(e);
        });
      });
    }

    // Listen for changes on insurance input
    const insuranceInput = document.querySelector('#how-much-would-you-like-to-insure-your-item');
    if (insuranceInput) {
      insuranceInput.addEventListener('input', (e) => {
        this.handleInsuranceChange(e);
      });
    }

  }

  getCurrentRangeSliderPrice() {
    // Get the current range slider price from the updatePriceRange function in main-product.liquid
    const priceSlider = document.getElementById('priceSlider');
    if (!priceSlider) return 0;
    
    const sliderValue = parseInt(priceSlider.value);
    const priceRanges = [
      { value: '1-499.99', minValue: 0, maxValue: 499.99, price: '0'  },
      { value: '500-1499.99', minValue: 500, maxValue: 1499.99, price: '25' },
      { value: '1500-4999.99', minValue: 1500, maxValue: 4999.99, price: '50' },
      { value: '5000-9999.99', minValue: 5000, maxValue: 9999.99, price: '150' },
      { value: '10000-24999.99', minValue: 10000, maxValue: 24999.99, price: '400' },
      { value: '25000-49999.99', minValue: 25000, maxValue: 49999.99, price: '1000' },
      { value: '50000-99999.99', minValue: 50000, maxValue: 99999.99, price: '2000' },
      { value: '100000-infinity', minValue: 100000, maxValue: Infinity, price: '5000' },
    ];
    
    const selectedRange = priceRanges[sliderValue];
    return selectedRange ? parseFloat(selectedRange.price || 0) : 0;
  }

  handlePriceRangeChange(event) {
    // This function is called when the price range slider moves
    // Update the priceRangeSlider display with combined range + insurance values
    
    const priceRangeSlider = document.getElementById('priceRangeSlider');
    const priceRangeSlideContainer = document.querySelector('.price-range-slide');
    
    // Get current range slider price
    const currentRangePrice = this.getCurrentRangeSliderPrice();
    
    // Get current insurance cost
    const currentInsuranceCost = this.selectedOptions.get("insurance") || 0;
    
    // Sum both values
    const totalDisplayValue = currentRangePrice + currentInsuranceCost;
    
    // Update display
    if (priceRangeSlider) {
      priceRangeSlider.textContent = totalDisplayValue.toString();
    }
    
    // Show/hide container based on total value
    if (priceRangeSlideContainer) {
      priceRangeSlideContainer.style.display = totalDisplayValue > 0 ? 'block' : 'none';
    }
    
    // Reset insurance-related pricing when slider changes
    this.selectedOptions.delete("sliderPrice");
    this.updateTotalPrice();
  }

  handleInsuranceChange(event) {
    const insuranceInput = event.target;
    const inputValue = parseFloat(insuranceInput.value) || 0;
    const priceRangeSlider = document.getElementById('priceRangeSlider');
    const priceRangeSlideContainer = document.querySelector('.price-range-slide');
    
    if (inputValue > 0) {
      // Calculate insurance cost: $1 for each rounded up $100
      const roundedUpValue = Math.ceil(inputValue / 100) * 100;
      const insuranceCost = roundedUpValue / 100;
      
      // Get current range slider price (if any)
      const currentRangePrice = this.getCurrentRangeSliderPrice();
      
      // Sum both values
      const totalDisplayValue = currentRangePrice + insuranceCost;
      
      // Display combined value in priceRangeSlider
      if (priceRangeSlider) {
        priceRangeSlider.textContent = totalDisplayValue.toString();
      }
      
      // Show the price range slide container
      if (priceRangeSlideContainer) {
        priceRangeSlideContainer.style.display = 'block';
      }
      
      // Store insurance cost in selectedOptions for total price calculation
      this.selectedOptions.set("insurance", insuranceCost);
    } else {
      // Get current range slider price (if any)
      const currentRangePrice = this.getCurrentRangeSliderPrice();
      
      // Display only range slider price when no insurance
      if (priceRangeSlider) {
        priceRangeSlider.textContent = currentRangePrice.toString();
      }
      
      // Hide container if no range price and no insurance
      if (priceRangeSlideContainer) {
        priceRangeSlideContainer.style.display = currentRangePrice > 0 ? 'block' : 'none';
      }
      
      // Remove insurance cost from selectedOptions when no insurance
      this.selectedOptions.delete("insurance");
    }
    
    // Update total price
    this.updateTotalPrice();
  }

  getCartItemCount() {
    // Get cart item count from cart bubble
    const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (cartCountBubble) {
      const count = parseInt(cartCountBubble.textContent) || 0;
      return count;
    }
    
    // Alternative: check cart items directly
    const cartItems = document.querySelectorAll('.cart-item, [data-cart-item], [name="updates[]"]');
    if (cartItems.length > 0) {
      return cartItems.length;
    }
    
    // Fallback: try to get from window.cart if available
    if (window.cart && window.cart.item_count) {
      return window.cart.item_count;
    }
    
    // Fallback: check for CartItems element and its currentItemCount
    const cartItemsElement = document.querySelector('cart-items');
    if (cartItemsElement && cartItemsElement.currentItemCount) {
      return cartItemsElement.currentItemCount;
    }
    
    return 0;
  }

  updateTotalPrice() {
    let totalPrice = this.basePrice;

    console.log('=== Price Calculation Debug ===');
    console.log('Base price:', this.basePrice);
    console.log('Selected options:', this.selectedOptions);

    // Add all selected option prices (including negative values for discounts)
    for (let [key, price] of this.selectedOptions.entries()) {
      console.log(`Adding ${key}: ${price}`);
      totalPrice += price;
    }

    console.log('Total before minimum check:', totalPrice);

    // Ensure price doesn't go below 0
    totalPrice = Math.max(0, totalPrice);
    
    console.log('Final total price:', totalPrice);

    // Format price with appropriate currency
    const formattedPrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      trailingZeroDisplay: "stripIfInteger",
    }).format(totalPrice);

    console.log('Formatted price:', formattedPrice);

    // Update all price elements on the page
    document.querySelectorAll(this.priceSelectors).forEach((element) => {
      console.log('Updating price element:', element);
      element.textContent = formattedPrice;
    });

    // Update fixed bar price
    if (this.fixedBarPrice) {
      console.log('Updating fixed bar price:', this.fixedBarPrice);
      this.fixedBarPrice.textContent = formattedPrice;
    }

    // Dispatch custom event for other components that might need to know about price updates
    this.form.dispatchEvent(
      new CustomEvent("price:updated", {
        detail: { price: totalPrice },
        bubbles: true,
      })
    );
    
    console.log('=== End Price Calculation ===');
  }

  handleCustomNoteVisibility() {
    const customNoteSection = this.form.querySelector(
      '.form-section:has(textarea[name="properties[custom-note]"])'
    );
    if (!customNoteSection) return;

    const selectedDisplay = this.form.querySelector(
      'input[name="properties[display-preference]"]:checked'
    );
    if (
      selectedDisplay &&
      selectedDisplay.value.toLowerCase().includes("custom")
    ) {
      customNoteSection.style.display = "block";
    } else {
      customNoteSection.style.display = "none";
    }
  }

  initializeSelectedOptions() {
    // Get all pre-selected radio inputs
    this.form
      .querySelectorAll('input[type="radio"]:checked')
      .forEach((input) => {
        const priceElement = input
          .closest(".radio-container")
          .querySelector(".option-price");
        if (priceElement) {
          const price = this.extractPrice(priceElement.textContent);
          this.selectedOptions.set(input.name, price);
        }
      });

    // Update price initially
    this.updateTotalPrice();
  }

  handleOptionChange(event) {
    const input = event.target;
    const container = input.closest(".radio-container");
    const priceElement = container ? container.querySelector(".option-price") : null;

    console.log('Option changed:', input.name, 'Value:', input.value);
    console.log('Container:', container);
    console.log('Price element:', priceElement);

    if (priceElement) {
      const price = this.extractPrice(priceElement.textContent);
      console.log('Extracted price:', price);
      this.selectedOptions.set(input.name, price);
          } else {
        // For options without explicit price elements, check if there's a data-price attribute
        const dataPrice = input.getAttribute('data-price') || input.closest('.album-details-form__field')?.getAttribute('data-price');
        if (dataPrice) {
          const price = this.extractPrice(dataPrice);
          console.log('Data price found:', price);
          this.selectedOptions.set(input.name, price);
        } else {
          // For media type options, check if there's a default price of 0 or set based on value
          if (input.name === "properties[media-type]") {
            // Media types might have base pricing of 0 or specific amounts
            const mediaTypePrice = 0; // Default for media types
            console.log('Media type selected, setting default price:', mediaTypePrice);
            this.selectedOptions.set(input.name, mediaTypePrice);
          } else {
            console.log('No price found, removing from selectedOptions');
            this.selectedOptions.delete(input.name);
          }
        }
      }

    console.log('Current selectedOptions:', this.selectedOptions);
    this.updateTotalPrice();
  }

  extractPrice(priceString) {
    if (!priceString) return 0;
    // Remove currency symbol and any other non-numeric characters except decimal point and minus
    const price = priceString.replace(/[^0-9.-]/g, "");
    const parsed = parseFloat(price);
    return isNaN(parsed) ? 0 : parsed;
  }

  setupFormDataCollection() {
    // Listen for the form:data event from product-info.js
    document.addEventListener("form:data", (event) => {
      if (!event.detail || !event.detail.form) return;

      // Add our custom properties to the form data
      const properties = this.collectFormProperties();

      // Get the existing form data from the event
      const formData = event.detail.form;

      // Add our properties to the form data
      formData.append("properties", JSON.stringify(properties));
    });
  }

  collectFormProperties() {
    const properties = {};

    // Collect radio button selections
    this.form
      .querySelectorAll('input[type="radio"]:checked')
      .forEach((radio) => {
        const fieldLabel = this.getFieldLabel(radio);
        const value = radio.value;
        const price = this.getOptionPrice(radio);

        // Remove 'properties[]' from the field label for cleaner display
        const cleanLabel = fieldLabel.replace('properties[', '').replace(']', '');
        properties[cleanLabel] = {
          value: value,
          price: price || 0,
        };
      });

    // Collect custom note if visible
    const customNoteField = this.form.querySelector(
      'textarea[name="properties[custom-note]"]'
    );
    if (
      customNoteField &&
      customNoteField.closest(".form-section").style.display !== "none"
    ) {
      properties["Custom Note"] = {
        value: customNoteField.value,
        price: 0,
      };
    }

    return properties;
  }

  getFieldLabel(input) {
    // Try to find the section title first
    const section = input.closest(".form-section");
    if (section) {
      const title = section.querySelector(".form-title");
      if (title) return title.textContent.trim();
    }

    // Fallback to input name
    return input.name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");ProductFormPriceUpdater
  }

  getOptionPrice(input) {
    const container = input.closest(".radio-container");
    if (!container) return 0;

    const priceElement = container.querySelector(".option-price");
    if (!priceElement) return 0;

    return this.extractPrice(priceElement.textContent);
  }

  initializeDisplayFiltering() {
    // Initialize display filtering on first load
    const checkedOption = document.querySelector(
      'input[name="properties[media-type]"]:checked'
    );
    if (checkedOption) {
      const selectedType = checkedOption.getAttribute("data-type");
      this.filterDisplayOptions(selectedType);
      this.toggleKeyholeMounts(selectedType);
    }

    // Add event listeners for media options
    this.mediaOptions.forEach((option) => {
      option.addEventListener("change", (e) => {
        const selectedType = e.target.getAttribute("data-type");
        this.filterDisplayOptions(selectedType);
        this.toggleKeyholeMounts(selectedType);
      });
    });
  }

  initializeKeyholeMountsVisibility() {
    if (!this.keyholeMountsSection) {
      return;
    }

    const checkedOption = this.form.querySelector(
      'input[name="properties[media-type]"]:checked'
    );
    if (checkedOption) {
      const selectedType = checkedOption.getAttribute("data-type");
      this.toggleKeyholeMounts(selectedType);
    }
  }

  toggleKeyholeMounts(selectedType) {
    if (!this.keyholeMountsSection) return;

    const isRecordType = selectedType === "records";
    const isVinylCaseType = selectedType === "vinyl" || selectedType === "vinyl-case";
    const shouldShowKeyholeMounts = isRecordType || isVinylCaseType;
    
    // Show record-size section only for vinyl/records types
    const shouldShowRecordSize = isRecordType || isVinylCaseType;
    this.recordSizeSection.style.display = shouldShowRecordSize ? "block" : "none";
    this.keyholeMountsSection.style.display = shouldShowKeyholeMounts ? "block" : "none";

    // Sync the `required` attribute on Record Size radios with section visibility.
    // Leaving `required` on hidden radios blocks add-to-cart silently via native form validation.
    const recordSizeInputs = this.recordSizeSection.querySelectorAll('input[type="radio"]');
    recordSizeInputs.forEach((input) => {
      if (shouldShowRecordSize) {
        input.setAttribute('required', '');
      } else {
        input.removeAttribute('required');
      }
    });

    // Clear record-size selection if not vinyl/records
    if (!shouldShowRecordSize) {
      recordSizeInputs.forEach((input) => {
        if (input.checked) {
          input.checked = false;
          const optionKey = `record-size-${input.value}`;
          this.selectedOptions.delete(optionKey);
        }
      });
      // Clear the hidden form field as well
      const recordSizeHidden = this.form.querySelector('input[name="properties[record-size]"]');
      if (recordSizeHidden) {
        recordSizeHidden.value = '';
      }
    }

    if (!shouldShowKeyholeMounts) {
      // If not record type or vinyl case type, uncheck all keyhole mount checkboxes and remove their prices
      const keyholeInputs = this.keyholeMountsSection.querySelectorAll('input[type="checkbox"]');
      keyholeInputs.forEach((input) => {
        if (input.checked) {
          input.checked = false;
          const optionKey = `keyhole-mount-${input.value}`;
          this.selectedOptions.delete(optionKey);
        }
      });
      this.updateTotalPrice();
    }
  }

  initializeServiceTypeVisibility() {
    // Initial visibility update based on default selection
    const defaultSelected = document.querySelector(
      'input[name="properties[media-type]"]:checked'
    );
    if (defaultSelected) {
      this.updateServiceTypeVisibility(defaultSelected.dataset.type);
    }

    // Add event listeners for media variant changes
    this.mediaOptions.forEach((input) => {
      input.addEventListener("change", (e) => {
        const selectedType = e.target.dataset.type;
        this.updateServiceTypeVisibility(selectedType);
      });
    });
  }

  updateServiceTypeVisibility(selectedType) {
    if (!this.serviceTypeOptions) {
      return;
    }

    // First pass - show/hide options and find first visible one
    let firstVisibleOption = null;
    this.serviceTypeOptions.forEach((option) => {
      const allowedTypes = (option.dataset.allowedTypes || "").split(",");
      
      if (!allowedTypes.length || allowedTypes.includes(selectedType)) {
        option.style.display = "block";
        if (!firstVisibleOption) {
          firstVisibleOption = option;
        }
      } else {
        option.style.display = "none";
      }
    });

    // Second pass - handle radio selection
    if (firstVisibleOption) {
      const currentChecked = this.form.querySelector('input[name="properties[service-type]"]:checked');
      
      // If current checked radio is hidden or none is checked, select first visible
      if (!currentChecked || currentChecked.closest('.service-type-option').style.display === 'none') {
        const radioToCheck = firstVisibleOption.querySelector('input[type="radio"]');
        if (radioToCheck) {
          if (currentChecked) {
            currentChecked.checked = false;
          }
          radioToCheck.checked = true;
          radioToCheck.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }
  }

  filterDisplayOptions(selectedType) {
    this.displayOptions.forEach((option) => {
      const optionType = option.getAttribute("data-type");
      const shouldDisplay = optionType === selectedType;
      option.style.display = shouldDisplay ? "block" : "none";
    });

    // If the previously-checked Display Preference is no longer visible for the
    // newly-selected media type, clear it. Don't auto-pick a replacement —
    // the user must actively choose.
    const currentChecked = this.form.querySelector('input[name="properties[display-preference]"]:checked');
    if (currentChecked && currentChecked.closest('.album-details-form__field').style.display === 'none') {
      currentChecked.checked = false;
      currentChecked.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  resetAllFormFields(selectedMediaType) {
    // Reset all text inputs and textareas
    const textInputs = document.querySelectorAll('input[type="text"], textarea');
    textInputs.forEach(input => {
      if (!input.name.includes('media-type')) {
        input.value = '';
      }
    });

    // Reset all checkboxes
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });

    // Reset all radio buttons except media type and set defaults
    const radioInputs = document.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(radio => {
      if (!radio.name.includes('media-type')) {
        radio.checked = false;
      }
    });

    // Set default radio button selections for non-media-type fields
    const defaultSelections = [
      'input[name="properties[service-type]"][value="Grading (We authenticate, document, label and case with a grade)"]',
      'input[name="properties[expedited]"][value="None"]',
      'input[name="properties[authentication]"][value="None"]'
    ];
    
    defaultSelections.forEach(selector => {
      const radioButton = document.querySelector(selector);
      if (radioButton) {
        radioButton.checked = true;
        // Trigger change event to update pricing
        radioButton.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Reset insurance input
    const insuranceInput = document.querySelector('#how-much-would-you-like-to-insure-your-item');
    if (insuranceInput) {
      insuranceInput.value = '';
    }

    // Reset price range slider
    const priceSlider = document.getElementById('priceSlider');
    if (priceSlider) {
      priceSlider.value = 0; // Reset to first position
      // Trigger the updatePriceRange function manually
      const event = new Event('input');
      priceSlider.dispatchEvent(event);
    }

    // Reset priceRangeSlider display
    const priceRangeSlider = document.getElementById('priceRangeSlider');
    const priceRangeSlideContainer = document.querySelector('.price-range-slide');
    if (priceRangeSlider) {
      priceRangeSlider.textContent = '';
    }
    if (priceRangeSlideContainer) {
      priceRangeSlideContainer.style.display = 'none';
    }

    // Clear selected options
    this.selectedOptions.clear();

    // Trigger media type pricing after reset
    setTimeout(() => {
      const selectedMediaTypeRadio = document.querySelector('input[name="properties[media-type]"]:checked');
      if (selectedMediaTypeRadio) {
        console.log('Triggering media type pricing after reset');
        selectedMediaTypeRadio.setAttribute('data-reset-triggered', 'true');
        selectedMediaTypeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 50);

    // Update total price
    this.updateTotalPrice();

    console.log('Form fields reset for media type:', selectedMediaType);
  }

  handleKeyholeMountChange(event) {
    const checkbox = event.target;
    const price = parseFloat(checkbox.dataset.price || 0);
    const optionKey = `keyhole-mount-${checkbox.value}`;

    // Check if current media type is vinyl case
    const selectedMediaType = document.querySelector('input[name="properties[media-type]"]:checked');
    const isVinylCaseType = selectedMediaType && 
      (selectedMediaType.value.toLowerCase().includes('vinyl') || 
       selectedMediaType.getAttribute('data-type') === 'vinyl' || 
       selectedMediaType.getAttribute('data-type') === 'vinyl-case');

    if (isVinylCaseType) {
      // For vinyl case, we just track if any checkbox is checked for yes/no logic
      // But we still need to handle pricing for the first checked item
      if (checkbox.checked) {
        this.selectedOptions.set('keyhole-mount-vinyl-case', price);
      } else {
        // Check if any other checkboxes are still checked
        const anyChecked = this.keyholeMountsSection.querySelector('input[type="checkbox"]:checked');
        if (!anyChecked) {
          this.selectedOptions.delete('keyhole-mount-vinyl-case');
        }
      }
    } else {
      // Original logic for other media types
      if (checkbox.checked) {
        this.selectedOptions.set(optionKey, price);
      } else {
        this.selectedOptions.delete(optionKey);
      }
    }

    this.updateTotalPrice();
  }
}

// Initialize the price updater when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  window.priceUpdater = new ProductFormPriceUpdater();
});
